<template>
  <div class="page10">
    <div class="bottom"></div>
    <div class="main">
      <div class="bg"></div>
      <img @click="jump" class="back" src="../../static/img/back.png" alt="" />
      <img class="pic" src="../../static/img/tcg.png" alt="" />
      <img class="name" src="../../static/img/tcg-tl.png" alt="" />
      <div class="word">
        <div>
          樟树等树木老叶旁长出了嫩绿的新叶，“之”字形栈道向远处延伸，白鹭翩飞的湿地与江堤内大红桥吊、如织航船构成了一幅和谐唯美的画卷。在太仓港区新材料产业园区景观整治提升工程的现场，感觉着太仓经济的“含绿量”正在稳步提升。
        </div>
        <div>
          作为太仓经济社会发展排头兵，港区坚持生态优先、绿色发展，加大财政资金投入，升级生态环境保护和修复档次，提高经济“含绿量”。据不完全统计，2020年，港区投入近6亿元资金用于长江、吴淞江生态环境保护和修复。同时，太仓还通过野墅沟、老浏河、吴塘河、盐铁塘、新浏河等十多条河道沟通吴淞江去上海。
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {};
  },
  methods: {
    jump() {
      this.$router.push("/page1");
    },
  },
  mounted() {
    let Main = document.querySelector(".main");
    let MainW = Main.getBoundingClientRect().width;
    Main.style.height = (MainW / 750) * 1500 + "px";
  },
};
</script>

<style scoped>
.page10 {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  overflow: hidden;
}
.page10 .bottom{
  position:absolute;
  width:100%;
  height:100%;
  top:0;
  left:0;
  background: #89d7c6;
  opacity:0.5;
}
.page10 .main {
  position: absolute;
  left: 0;
  top: -100%;
  bottom: -100%;
  margin: auto;
  width: 100%;
  height: auto;
}
.page10 .bg {
  position: absolute;
  /* width: 50%;
  height: 50%;
  background: url("../../static/img/page2-bg.jpg");
  background-size: 100% 100%;
  top:calc((100vh - 50%) / 2);
  left:calc((100vw - 50%) / 2); 
  animation: bgdh 0.5s ease-out 1;
  animation-fill-mode: forwards; */
   width: 100%;
   height: 100%;
   background: url("../../static/img/page2-bg.jpg");
   background-size: 100% 100%;
   border-radius: 50%;
   transform: scale(0.2);
   animation: bgdh 0.5s linear 1;
   animation-fill-mode: forwards;
}
.back {
  width: 10.13%;
  position: absolute;
  top: 71%;
  left: 10%;
  opacity:0;
  animation: show 2s 0.5s linear 1;
  animation-fill-mode: forwards;
}
.pic {
  width: 52.19%;
  position: absolute;
  top: 13%;
  left: 17%;
  opacity: 0;
  animation: show 2s 1.5s linear 1;
  animation-fill-mode: forwards;
}
.name {
  width: 13.07%;
  position: absolute;
  top: 10%;
  left: 74%;
  opacity:0;
  animation: show 2s 0.5s linear 1;
  animation-fill-mode: forwards;
}
.word {
  width: 67%;
  height: 24%;
  position: absolute;
  left: 16%;
  top: 61%;
  transform:rotateZ(90deg);
  /* background:gray; */
  overflow: auto;
  color: #17848b;
  text-indent: 42px;
  line-height: 28px;
  letter-spacing: 5px;
  opacity: 0;
  animation: show 2s 2s linear 1;
  animation-fill-mode: forwards;
}
@keyframes show {
  0% {
    opacity: 0;
  }
  100% {
    opacity: 1;
  }
}
/* @keyframes bgdh {
  0%{
    width: 50%;
    height: 50%;
    border-radius: 50%;
    opacity:0;
    top:calc((100vh - 50%) / 2);
    left:calc((100vw - 50%) / 2);
  }
  100%{
    width: 100%;
    height: 100%;
    border-radius: 0;
    top:0;
    left:0;
    opacity:1;
  }
} */
@keyframes bgdh {
  0%{
    border-radius: 50%;
    transform: scale(0.2)
  }
  100%{
    border-radius: 0 ;
    transform: scale(1)
  }
}
</style>



// WEBPACK FOOTER //
// src/components/page10.vue